export function measureTextHeight(ctx, text) {
  const metrics = ctx.measureText(text);
  const ascent = metrics.actualBoundingBoxAscent ?? 8;
  const descent = metrics.actualBoundingBoxDescent ?? 4;
  return ascent + descent;
}

export function getInitialJitter(meta, index, threshold = 8, amount = 4) {
  const point = meta.data[index];
  const prev = meta.data[index - 1];
  const next = meta.data[index + 1];

  const closePrev = prev && Math.abs(prev.y - point.y) <= threshold;
  const closeNext = next && Math.abs(next.y - point.y) <= threshold;

  if (!closePrev && !closeNext) return 0;
  if (closePrev && !closeNext) return -amount;
  if (!closePrev && closeNext) return amount;

  return index % 2 === 0 ? -amount : amount;
}

export function drawNonOverlappingLabel(
  ctx,
  text,
  x,
  y,
  placed,
  {
    font = "10px sans-serif",
    color = "black",
    align = "center",
    baseline = "bottom",
    stepY = 14,
    maxAttempts = 10,
    minY = 8,
    maxY = Infinity,
  } = {},
) {
  ctx.font = font;
  ctx.fillStyle = color;
  ctx.textAlign = align;
  ctx.textBaseline = baseline;

  const textWidth = ctx.measureText(text).width;
  const textHeight = measureTextHeight(ctx, text);

  function collides(x, y) {
    for (const lbl of placed) {
      const dx = Math.abs(lbl.x - x);
      const dy = Math.abs(lbl.y - y);

      const horizontalOverlap = dx < textWidth / 2 + lbl.width / 2;
      const verticalOverlap = dy < textHeight / 2 + lbl.height / 2;

      if (horizontalOverlap && verticalOverlap) return true;
    }
    return false;
  }

  let bestY = null;

  for (let k = 0; k <= maxAttempts; k++) {
    let offsets;

    if (y - minY < stepY) {
      offsets = k === 0 ? [0] : [k, -k];
    } else {
      offsets = k === 0 ? [0] : [-k, k];
    }

    for (const offset of offsets) {
      const candidateY = y + offset * stepY;

      if (candidateY < minY || candidateY > maxY) continue;

      if (!collides(x, candidateY)) {
        bestY = candidateY;
        break;
      }
    }

    if (bestY !== null) break;
  }

  const finalY = bestY ?? Math.min(Math.max(y, minY), maxY);

  ctx.fillText(text, x, finalY);

  placed.push({
    x,
    y: finalY,
    width: textWidth,
    height: textHeight,
  });
}
